<template>
  <x-dialog
    width="50%"
    :dialogTitle="dialogTitle"
    :dialogState="addDomainDialog"
    @toggleModal="closeDialog"
    :actions="{
      show: true,
      secondaryButtonFunction: closeDialog,
      primaryButtonFunction: addDomain,
      primaryButtonShow: true,
      secondaryButtonText: 'Cancel',
      primaryButtonText: 'Add domain'
    }"
  >
    <template slot="dialog_data">
      <v-card-text class="px-8">
        <v-row align="center" justify="start">
          <v-col sm="3">
            <span class="formInputLabel mt-0">Domain name</span>
          </v-col>
        </v-row>
        <v-text-field
              solo
              filled
              flat
              tile
              height="52px"
              background-color="#E5E5E5 !important"
              v-model="domainName"
              @keyup.enter="addDomain"
            ></v-text-field>
      </v-card-text> </template
  ></x-dialog>
</template>

<script>
import PreferencesService from '@/services/PreferencesService';
import PreferenceHelper from '@/helpers/PreferenceHelper';
export default {
  data() {
    return {
      dialogTitle: 'Add a domain',
      addDomainDialog: false,
      domainName: '',
      preferenceServiceHelper: null
    };
  },
  props: {
    dialogOpen: Boolean
  },
  created: function() {
    this.preferenceServiceHelper = new PreferenceHelper();
    document.addEventListener('keyup', this.escapeKeyListener);
  },
  destroyed: function() {
    document.removeEventListener('keyup', this.escapeKeyListener);
  },
  mounted() {
    this.addDomainDialog = this.dialogOpen;
  },
  methods: {
    escapeKeyListener: function(evt) {
      if (evt.keyCode === this.escapeKeyCode && this.addDomainDialog) {
        this.closeDialog();
      }
    },
    async addDomain() {
      let reqObject = this.preferenceServiceHelper.createPreferenceBody(
        'orgDomain',
        { value: this.domainName },
        'domain'
      );
      if(!this.validator(this.domainName, 'validDomain')) {
        this.snackbar('error', 'Not a Valid Domain');
        return;
      }
      try {
        await PreferencesService.addPreference(
          this.$preference.DOMAINS,
          reqObject
        );
        this.snackbar('success', this.$message.DOMAIN_ADDED_SUCCESS);
        this.$emit('addSuccess');
        this.closeDialog();
      } catch (err) {
        this.snackbar('error', err);
      }
    },
    closeDialog() {
      this.addDomainDialog = false;
      this.domainName = '';
      this.$emit('closeAddOverlay', true);
    }
  },
  beforeDestroy() {}
};
</script>
